"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _localization = require("@lt/localization");

var _HotelOfferPrice = _interopRequireWildcard(require("../HotelOfferPrice"));

var _Button = _interopRequireDefault(require("../Button"));

var _index = require("../../proptypes/hotel/index");

var _excluded = ["operatorName", "onClick", "included"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var subTextArray = [_localization.i18n.t('hotel.offer.withFlight')];

var HotelOfferItem = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var operatorName = _ref.operatorName,
      onClick = _ref.onClick,
      included = _ref.included,
      priceProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var includedServices = included.map(function (item) {
    return String(item.name).toLowerCase();
  });
  return /*#__PURE__*/_react["default"].createElement(StyledOfferitem, {
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(FlexContainer, null, /*#__PURE__*/_react["default"].createElement(StyledText, null, operatorName), /*#__PURE__*/_react["default"].createElement(StyledHotelOfferPrice, priceProps)), /*#__PURE__*/_react["default"].createElement(StyledSubText, null, [].concat(subTextArray, (0, _toConsumableArray2["default"])(includedServices)).join(', ')));
});

HotelOfferItem.displayName = 'HotelOfferItem';
var StyledHotelOfferPrice = (0, _styledComponents["default"])(_HotelOfferPrice["default"]).withConfig({
  displayName: "HotelOfferItem__StyledHotelOfferPrice",
  componentId: "sc-a0uaat-0"
})(["", "{font-size:14px;color:", ";}"], _HotelOfferPrice.StyledPrice, function (props) {
  return props.theme.colors.blackBase;
});
var StyledOfferitem = (0, _styledComponents["default"])(_Button["default"]).attrs({
  functional: true
}).withConfig({
  displayName: "HotelOfferItem__StyledOfferitem",
  componentId: "sc-a0uaat-1"
})(["height:50px;width:100%;padding:10px;border-top:solid 1px transparent;&:hover{background-color:", ";}&:not(:first-child):not(:hover){border-color:#eaeaea;}"], function (props) {
  return props.theme.colors.solitude;
});

var FlexContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferItem__FlexContainer",
  componentId: "sc-a0uaat-2"
})(["display:flex;justify-content:space-between;align-items:center;"]);

var StyledText = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferItem__StyledText",
  componentId: "sc-a0uaat-3"
})(["", " color:", ";text-align:left;display:flex;"], function (props) {
  return props.theme.typography.text1;
}, function (props) {
  return props.theme.colors.blackLight;
});

var StyledSubText = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferItem__StyledSubText",
  componentId: "sc-a0uaat-4"
})(["", " color:", ";text-align:left;display:flex;"], function (props) {
  return props.theme.typography.text3;
}, function (props) {
  return props.theme.colors.greyLight;
});

HotelOfferItem.defaultProps = {
  included: null
};
HotelOfferItem.propTypes = _objectSpread(_objectSpread({
  onClick: _propTypes["default"].func.isRequired,
  operatorName: _propTypes["default"].string.isRequired
}, _HotelOfferPrice["default"].propTypes), {}, {
  included: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    code_name: _propTypes["default"].string.isRequired
  }).isRequired),
  availability: _index.AvailabilityPropTypes.isRequired
});
var _default = HotelOfferItem;
exports["default"] = _default;